import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import { gridProperties } from '@/services/column.config'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import {
  calculateGridHeight,
  showNotification,
  calculatePerimeterBuildingFootprint,
  customComparator,
} from '@/services/calculate'
import Pagination from '@/components/DynamicComponents/Pagination'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
    'export-template': exportTemplates,
  },
  props: {
    tabKey: String,
    role: String,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      if (rule.field === 'tenantName') {
        if (String(value).length > 100) {
          callback(
            new Error(
              'Tenant name must be less than or equals to 100 characters',
            ),
          )
        } else {
          callback()
        }
      } else {
        const reg = /^-?[1-9]\d{0,18}$/
        if (!reg.test(value)) {
          callback(new Error('Please enter valid tenant SF'))
        } else if (value > 9999999) {
          callback(
            new Error(
              'Tenant SF should less than or equals to 9999999!',
            ),
          )
        } else {
          callback()
        }
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'tenantName',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      tenantBankList: [],
      visible: false,
      modalTitle: '',
      form: {
        tenantName: undefined,
        tenantSF: undefined,
        tenantType: undefined,
        tenantTypeId: undefined,
        isActive: 1,
        perimeter: undefined,
      },
      rules: {
        tenantName: [
          {
            required: true,
            message: 'Please enter tenant name',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        tenantSF: [
          {
            required: true,
            message: 'Please enter tenant SF',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        tenantType: [
          {
            required: true,
            message: 'Please select tenant type',
            trigger: 'change',
          },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '410px',
      tenantTypeList: [],
      tempArrayList: [],
      filters: {},
      tableState: null,
      exportClicked: false,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
    this.getDropdown()
  },
  mounted() {
    this.$root.$on('deleteTenantBank', this.deleteBank)
    this.$root.$on('cloneTenantBank', this.cloneBank)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '11') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.tenantBankList = []
        this.loading = true
        this.getDropdown()
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('deleteTenantBank')
    this.$root.$off('cloneBank')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked) return false
          else return true
        }
      }
      this.columnDefs = gridProperties.master.columns.tenantBank
    },

    // Refresh Tenant Banks
    refreshBanks() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.tenantBankList = []
      this.page = 0
      this.defaultSortedBy = 'tenantName'
      this.defaultSortOrder = true
      this.selectedRowKeys = []
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'tenantName',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getBanks(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New Tenant Bank
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New'
      this.form.tenantTypeId = undefined
      this.isActive = 1
      this.perimeter = undefined
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save Tenant Bank
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.form.tenantTypeId = this.tenantTypeList.find(
            i => i.tenantType === this.form.tenantType,
          ).id
          this.form.perimeter = calculatePerimeterBuildingFootprint(
            this.form.tenantSF,
          )
          this.spinner = true
          let url = masterAPIs.tenantBank.add
          if (this.modalTitle === 'Copy') {
            url = masterAPIs.tenantBank.clone(this.form.id)
          }
          instance
            .post(url, this.form)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                'Create Tenant Bank',
                'Tenant Bank created successfully!',
              )
              const id = _.get(response.data, 'result.id', undefined)
              this.$refs.ruleForm.resetFields()
              this.$router.push(`tenant-bank/${id}`)
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Load Tenant Banks
    getBanks(params, type) {
      instance
        .post(masterAPIs.tenantBank.list, {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          tenantName: _.get(this.filters, 'tenantName', undefined),
          tenantSF: _.get(this.filters, 'tenantSF', undefined),
          tenantType: _.get(this.filters, 'tenantType', undefined),
        })
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.tenantBankList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'tenantBankTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.tenantBank.delete, ids)
        .then(response => {
          showNotification(
            'success',
            'Delete Tenant Bank',
            _.get(response.data, 'message', undefined),
          )
          this.refreshBanks()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All Tenant Banks
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected tenant bank ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected tenant
              bank
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(null)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete Tenant Bank
    deleteBank(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.tenantName}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this tenant
              bank
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.tenantBankList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'tenantName'
        this.defaultSortOrder = true
      }
      this.getBanks(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    // Tenant Type List
    getDropdown() {
      instance
        .post(masterAPIs.tenantType.list, {
          pageSize: 10000,
          currentPage: 0,
          sortColumn: 'tenantType',
          isAscending: true,
        })
        .then(response => {
          this.tenantTypeList = _.get(response.data, 'result', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    // Copy Tenant Bank
    cloneBank(data) {
      this.visible = true
      this.modalTitle = 'Copy'
      this.form.tenantName = data.tenantName + ' - Copy'
      this.form.tenantSF = data.tenantSF
      this.form.tenantType = data.tenantType
      this.form.tenantTypeId = data.tenantTypeId
      this.form.id = data.id
      this.form.isActive = data.isActive
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'tenantBankTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.tenantBankList = []
      this.selectedRowKeys = []
      this.getBanks(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.tenantBankList = []
      this.loading = true
      this.page = 0
      this.getBanks(this.gridOptions)
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: screenType.tenantBank,
          columnDetails: JSON.stringify(this.tableState),
        }
        this.$emit('updateColumns', request)
      }
    },

    getColumnSettings(params) {
      if (this.role === 'Admin') {
        instance
          .get(masterAPIs.columnSetting.get(screenType.tenantBank))
          .then(response => {
            const tableState = _.get(response.data, 'result.columnDetails', null)
            this.setColumnSettings(params, tableState)
          })
          .catch(error => {
            this.spinner = false
            errorService(error)
          })
      } else {
        this.setColumnSettings(params)
      }
      this.getBanks(params)
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = false
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'tenantName'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'tenantName',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
